
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import stopPropagationFn from 'common/stop-propagation'

const useStyles = makeStyles({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
})

interface IScrollWrapperProps {
  maxHeight: string | number
  children: any
  className?: string
  stopPropagation?: boolean
}

const ScrollWrapper = ({ maxHeight, children, className, stopPropagation, ...rest }: IScrollWrapperProps) => {
  const classes = useStyles()
  return (
    <div
      {...rest}
      className={cn(className, classes.root)}
      style={{ maxHeight }}
      onScroll={(e) => {
        if (stopPropagation) {
          stopPropagationFn(e)
        }
      }}
    >
      {children}
    </div>
  )
}

export default ScrollWrapper
